import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractAccountOperation from "./AbstractAccountOperation.js";

/**
 * Opening balance sums all transactions up to the start of the context period excluded.
 */
export default class OpeningBalanceAccountOperation extends AbstractAccountOperation {
	getName() {
		return _("Opening Balance");
	}

	getShortName() {
		return _("OB");
	}

	static getType() {
		return "OpeningBalanceAccountOperation";
	}

	static getOperationType() {
		return "OpeningBalance";
	}
}
